export default [
  {
    slug: 'chad-wetherbee',
    name: 'Chad Wetherbee',
    website: 'http://chadwetherbee.com',
  },
  {
    slug: 'dan-lourenco',
    name: 'Dan Lourenco',
    website: 'https://www.linkedin.com/in/danlourenco',
  },
  // {
  //   slug: 'chris-forrette',
  //   name: 'Chris Forrette',
  //   website: 'http://chrisforrette.com',
  // },
  {
    slug: 'jason-leibowitz',
    name: 'Jason Leibowitz',
    website: 'http://leibowitz.me',
  },
  {
    slug: 'michael-buran',
    name: 'Michael Buran',
    website: 'http://www.michaelburan.com',
  },
  {
    slug: 'nayong-park',
    name: 'Nayong Park',
    website: 'http://nyplusg.com/members/nayong-park',
  },
  {
    slug: 'nick-ryan',
    name: 'Nick Ryan',
    website: 'https://nickcdryan.wordpress.com',
  },
  {
    slug: 'kristin-turner',
    name: 'Kristin Turner',
    website: 'http://www.kristin-l-turner.com',
  },
  {
    slug: 'johanna-kenney',
    name: 'Johnanna Kenney',
    website: 'http://jkenneydesign.com',
  },
  {
    slug: 'justin-shephard',
    name: 'Justin Shephard',
    website: 'https://www.linkedin.com/in/justinshephard',
  },
  {
    slug: 'christian-glover-wilson',
    name: 'Christian Glover Wilson',
    website: 'https://www.linkedin.com/in/gloverwilson/',
  },
];



// WEBPACK FOOTER //
// ./src/data/people.js